<template>
  <split-screen>
    <template v-slot:left>
      <event-list :events="events" prefix="calendar" />
    </template>

    <template v-slot:right>
      <EventDetail v-if="events && currentEvent" :event="currentEvent" prefix="calendar" />
      <div v-else class="flex items-center justify-center h-full relative">
        <BaseCalendar style="width: 40vw" en="Today" fr="Aujourd'hui" />
        <span class="absolute mt-16 lg:mt-18 flex items-center flex-col">
          <span style="font-size: 8vw">{{ day }}</span>
          <span v-if="lang === 'en'" class="bottom-label block w-full text-center">{{ month }}</span>
          <span v-else class="bottom-label block w-full text-center">{{ month_fr }}</span>
        </span>
      </div>
    </template>
  </split-screen>
</template>

<script>
import { format } from 'date-fns'
import { mapState } from 'vuex'
import SplitScreen from '@/views/SplitScreen'
import EventDetail from '@/components/EventDetail'
import EventList from '@/components/EventList'
export default {
  name: 'Calendar',
  data () {
    return {
    }
  },
  components: {
    EventDetail,
    EventList,
    SplitScreen
  },
  methods: {
    format
  },
  computed: {
    ...mapState([
      'events',
      'lang'
    ]),
    flatEvents () {
      return this.events.concat(this.childEvents)
    },
    childEvents () {
      return this.events.map(x => { return x.events }).flat()
    },
    currentEvent () {
      if (this.$route.params.date && this.$route.params.slug) {
        return this.flatEvents.find(x => {
          return x.date === this.$route.params.date && x.slug === this.$route.params.slug
        })
      } else {
        return false
      }
    },
    day () {
      return new Date().getDate()
    },
    month () {
      return new Date().toLocaleString('default', { month: 'long' })
    },
    month_fr () {
      return new Date().toLocaleString('fr-FR', { month: 'long' })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .bottom-label
    font-size: 2vw
</style>
